/* Список экранов студии на движке шаблона (engine-kit). Чистые функции без DOM и import.meta.env: их импортирует и
   vite.config.ts, чтобы записать список сборки в steos-build.json; scripts/verify-release-artifacts.mjs сверяет его с
   engine-default.json (вне канала staging список сборки обязан совпасть со значением по умолчанию). */
import defaults from './engine-default.json' with { type: 'json' };

/** Имена экранов: строки без пробелов по краям, в нижнем регистре, без повторов, без пустых и без «none».
    Не массив → null (список не задан). */
export function normalizeScreens(list: unknown): string[] | null {
  if (!Array.isArray(list)) return null;
  const names = list.filter((item): item is string => typeof item === 'string').map(item => item.trim().toLowerCase());
  return [...new Set(names.filter(name => name !== '' && name !== 'none'))];
}

/** undefined или '' → null (не задан); 'none' → []; 'voice, circle' → ['voice','circle']
    (разделители — запятые и пробелы; края обрезаны, нижний регистр, без повторов). Незнакомые имена остаются:
    их отсекает пересечение с ENGINE_READY в engine-screens.ts. */
export function parseEngineScreens(raw: string | undefined): string[] | null {
  if (typeof raw !== 'string') return null;
  const text = raw.trim();
  return text ? normalizeScreens(text.split(/[\s,]+/)) : null;
}

/** Псевдонимы экранов: circle и lipsync — один экран сервера who (CanonicalScreen бэкенда, MessagingStudioScreenContracts.cs),
    swap — пресет экрана dance («Стать персонажем»). */
const SCREEN_ALIASES: Readonly<Record<string, string>> = Object.freeze({ circle: 'who', lipsync: 'who', swap: 'dance' });

/** Каноническое имя экрана: края обрезаны, нижний регистр, псевдоним → экран сервера (circle, lipsync → who; swap → dance).
    По каноническим именам сверяются ENGINE_READY, список сборки, подмена проверок и me.ui_flags.native_screens. */
export function canonicalScreen(screen: string): string {
  const name = String(screen ?? '').trim().toLowerCase();
  return Object.hasOwn(SCREEN_ALIASES, name) ? SCREEN_ALIASES[name] : name;
}

/** Экраны на движке по умолчанию. [] до одного коммита переключения (инвариант I4: до него в production нового нет). */
export const ENGINE_DEFAULT: readonly string[] = Object.freeze(normalizeScreens(defaults) ?? []);
/** Экраны, движок которых готов к серверному режиму: канонические имена, по алфавиту, одной строкой.
    Строку пишет только node scripts/engine-ready.mjs add <экран> (конфликт слияния — sync <экраны обеих сторон>). */
export const ENGINE_READY: readonly string[] = Object.freeze(['avatar', 'collage', 'cover', 'dance', 'infog', 'mcard', 'photo', 'post', 'pshoot', 'reels', 'shoot', 'text', 'video', 'voice', 'who']);
